import MicSwitcher from "./MicSwitcher";
import RecordTime from "./RecordTime";
import RecordOperator from "./RecordOperator";

function Controller() {
  return (
    <div className="bg-#fff mb-2 w-[calc(100%-1rem)] m-x-2 shadow-[0_6px_16px_0_rgba(31, 37, 51, 0.08)] rounded-2.5 p-r-8 h-20 flex justify-between items-center mx-border-t">
      <MicSwitcher />
      <RecordTime />
      <RecordOperator />
    </div>
  );
}

export default Controller;
